<template>
  <div>
    <div>
      <content-block
        v-if="userBlock"
        :content="userBlock"
      />
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from '@nuxtjs/composition-api';
import ContentBlock from '~/components/ContentBlock.vue';
import { useContent } from '~/composables';

export default {
  components: {
    ContentBlock,
  },
  setup() {
    const userBlock = ref(null);
    const { loadBlocks } = useContent();
    const barIdentifier = 'promotional_bar';
    onMounted(async () => {
      if (barIdentifier) {
        const identifier = { identifiers: [barIdentifier] };
        const newBlock = await loadBlocks(identifier);
        const blockValue = newBlock.map((items) => items);
        if (!blockValue === null) {
          userBlock.value = blockValue?.[0].content;
        }
      }
    });
    return {
      ContentBlock,
      userBlock,
    };
  },

};
</script>
